<template>
  <div v-if="helpLinks" class="gitbook-help-wrapper">
    <b-dropdown
      variant="link"
      class="gitbook-help-link"
      toggle-class="gitbook-help-toggle p-0"
      no-caret
      right
    >
      <template #button-content>
        <span class="gitbook-help-btn">
          <b-icon icon="book" font-scale="0.85" class="mr-1" />
          {{ routeLabel }} 가이드
        </span>
      </template>
      <b-dropdown-item v-for="link in helpLinks" :key="link.url" :href="link.url" target="_blank">
        {{ link.text }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
const GITBOOK_BASE = 'https://quantifiedesg-inc.gitbook.io/esg-reporting-tool';

const ROUTE_HELP_MAP = {
  // 로그인 / 회원가입
  Login: [
    { text: '가이드: ERT 시작하기', path: '/zero-to-web/ert' },
    { text: 'FAQ: 자주 묻는 질문 TOP 10', path: '/ert-faq' }
  ],
  Signup: [
    { text: '가이드: ERT 시작하기', path: '/zero-to-web/ert' },
    { text: 'FAQ: 자주 묻는 질문 TOP 10', path: '/ert-faq' }
  ],
  // 메인페이지
  Main: [
    { text: '가이드: ERT 시작하기', path: '/zero-to-web/ert' },
    { text: '가이드: 새 보고서 생성하기', path: '/zero-to-web/1' },
    { text: '가이드: 차년도 보고에 활용하기', path: '/zero-to-web/1/undefined-1' },
    { text: 'FAQ: 자주 묻는 질문 TOP 10', path: '/ert-faq' }
  ],
  // 기본설정
  BasicSettings: [
    { text: '가이드: 새 보고서 생성하기', path: '/zero-to-web/1' },
    { text: 'FAQ: 보고서 생성 및 기본 설정', path: '/ert-faq/undefined-2/images-and-media' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  Publishing: [
    { text: '가이드: 최종 보고서 발간하기', path: '/zero-to-web/5/pdf' },
    { text: 'FAQ: 공개 및 PDF 생성', path: '/ert-faq/undefined-3/pdf' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  TeamSettings: [
    { text: '가이드: 팀원 초대하기', path: '/zero-to-web/2' },
    { text: 'FAQ: 계정 및 팀원 관리', path: '/ert-faq/undefined-1/editor' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  ThemeSettings: [
    { text: '가이드: 메인 페이지 제작하기', path: '/zero-to-web/1/undefined' },
    { text: 'FAQ: 목차 구성 및 메인 페이지', path: '/ert-faq/undefined-2/interactive-blocks' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  // 지표선택
  SelectGriIndicators: [
    { text: 'FAQ: 산업 반영 및 중요주제 선정', path: '/ert-faq/undefined-2/undefined' }
  ],
  SelectSasbIndicators: [
    { text: 'FAQ: 산업 반영 및 중요주제 선정', path: '/ert-faq/undefined-2/undefined' }
  ],
  SelectTcfdIndicators: [
    { text: 'FAQ: 산업 반영 및 중요주제 선정', path: '/ert-faq/undefined-2/undefined' }
  ],
  GetGriRecommendations: [
    { text: 'FAQ: 산업 반영 및 중요주제 선정', path: '/ert-faq/undefined-2/undefined' }
  ],
  GetSasbRecommendations: [
    { text: 'FAQ: 산업 반영 및 중요주제 선정', path: '/ert-faq/undefined-2/undefined' }
  ],
  GetTcfdRecommendations: [
    { text: 'FAQ: 산업 반영 및 중요주제 선정', path: '/ert-faq/undefined-2/undefined' }
  ],
  // 보고서 작성 - StoryBoard
  StoryBoardToCEdit: [
    { text: '가이드: 목차 작성하기', path: '/zero-to-web/3' },
    { text: 'FAQ: 목차 구성 및 메인 페이지', path: '/ert-faq/undefined-2/interactive-blocks' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  WriteStoryBoard: [
    { text: '가이드: 보고서 작성 및 시각화', path: '/zero-to-web/4' },
    { text: 'FAQ: 보고서 작성 및 수정', path: '/ert-faq/undefined-2/integrations' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  ReportCompare: [
    { text: '가이드: 보고서 작성 및 시각화', path: '/zero-to-web/4' },
    { text: 'FAQ: 보고서 작성 및 수정', path: '/ert-faq/undefined-2/integrations' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  StoryBoardSetting: [
    { text: '가이드: 목차 작성하기', path: '/zero-to-web/3' },
    { text: 'FAQ: 목차 구성 및 메인 페이지', path: '/ert-faq/undefined-2/interactive-blocks' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  ComponentSetting: [
    { text: '가이드: 시각적 요소 추가하기', path: '/zero-to-web/4/undefined' },
    { text: 'FAQ: 도식, 표, 그래프', path: '/ert-faq/undefined-2/undefined-1' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  FooterSetting: [
    { text: '가이드: 목차 작성하기', path: '/zero-to-web/3' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  // 문서함
  MgDataTables: [{ text: 'FAQ: 도식, 표, 그래프', path: '/ert-faq/undefined-2/undefined-1' }],
  MgDocuments: [{ text: 'FAQ: 보고서 작성 및 수정', path: '/ert-faq/undefined-2/integrations' }],
  MgBusinessCases: [
    { text: 'FAQ: 보고서 작성 및 수정', path: '/ert-faq/undefined-2/integrations' }
  ],
  MgCharts: [{ text: 'FAQ: 도식, 표, 그래프', path: '/ert-faq/undefined-2/undefined-1' }],
  // 검토 및 검증
  CheckReport: [
    { text: '가이드: 검증하기', path: '/zero-to-web/5/undefined' },
    { text: 'FAQ: 제3자 검증', path: '/ert-faq/undefined-3/3' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  AssuranceInfo: [
    { text: '가이드: 검증하기', path: '/zero-to-web/5/undefined' },
    { text: 'FAQ: 제3자 검증', path: '/ert-faq/undefined-3/3' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  ApplyAssurance: [
    { text: '가이드: 검증하기', path: '/zero-to-web/5/undefined' },
    { text: 'FAQ: 제3자 검증', path: '/ert-faq/undefined-3/3' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  CoVerification: [
    { text: '가이드: 검증하기', path: '/zero-to-web/5/undefined' },
    { text: 'FAQ: 제3자 검증', path: '/ert-faq/undefined-3/3' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  GetAssuranceReport: [
    { text: '가이드: 검증하기', path: '/zero-to-web/5/undefined' },
    { text: 'FAQ: 제3자 검증', path: '/ert-faq/undefined-3/3' },
    {
      text: '인터랙티브 가이드 (Arcade)',
      url: 'https://app.arcade.software/share/collections/isPmuNmupal7elHcWgHF'
    }
  ],
  // 번역
  BasicTranslateSet: [
    { text: '가이드: 번역하기', path: '/zero-to-web/5/undefined-1' },
    { text: 'FAQ: 보고서 번역', path: '/ert-faq/undefined-3/undefined' }
  ],
  GriTranslateSet: [
    { text: '가이드: 번역하기', path: '/zero-to-web/5/undefined-1' },
    { text: 'FAQ: 보고서 번역', path: '/ert-faq/undefined-3/undefined' }
  ],
  TcfdTranslateSet: [
    { text: '가이드: 번역하기', path: '/zero-to-web/5/undefined-1' },
    { text: 'FAQ: 보고서 번역', path: '/ert-faq/undefined-3/undefined' }
  ],
  SasbTranslateSet: [
    { text: '가이드: 번역하기', path: '/zero-to-web/5/undefined-1' },
    { text: 'FAQ: 보고서 번역', path: '/ert-faq/undefined-3/undefined' }
  ],
  DataCenterTranslateSet: [
    { text: '가이드: 번역하기', path: '/zero-to-web/5/undefined-1' },
    { text: 'FAQ: 보고서 번역', path: '/ert-faq/undefined-3/undefined' }
  ],
  StoryBoardTranslateSet: [
    { text: '가이드: 번역하기', path: '/zero-to-web/5/undefined-1' },
    { text: 'FAQ: 보고서 번역', path: '/ert-faq/undefined-3/undefined' }
  ],
  // 결제
  PaymentService: [
    { text: '가이드: 결제하기', path: '/ert/undefined-1' },
    { text: 'FAQ: 요금제 및 결제', path: '/ert-faq/undefined-1/markdown' }
  ],
  UserPaymentCheck: [{ text: 'FAQ: 요금제 및 결제', path: '/ert-faq/undefined-1/markdown' }],
  ProductPay: [
    { text: '가이드: 결제하기', path: '/ert/undefined-1' },
    { text: 'FAQ: 요금제 및 결제', path: '/ert-faq/undefined-1/markdown' }
  ]
};

// URL path 기반으로 현재 섹션명을 결정
const PATH_LABEL_RULES = [
  { test: p => p === '/main', label: '시작하기' },
  { test: p => p.startsWith('/editor/basic_settings'), label: '기본설정' },
  { test: p => p.startsWith('/editor/publishing'), label: '발간' },
  { test: p => p.startsWith('/editor/team_settings'), label: '팀원관리' },
  { test: p => p.startsWith('/editor/theme_settings'), label: '메인페이지' },
  {
    test: p => p.includes('indicators') || p.includes('recommendations') || p === '/editDCToC',
    label: '지표 선택'
  },
  {
    test: p => p.startsWith('/write_report') || p.startsWith('/story_board_settings'),
    label: '보고서 작성'
  },
  { test: p => p.startsWith('/mg_'), label: '문서함' },
  {
    test: p =>
      p.startsWith('/check_report') || p.includes('assurance') || p.startsWith('/co_verification'),
    label: '검토 및 검증'
  },
  { test: p => p.includes('eng') || p.includes('translate'), label: '번역' },
  {
    test: p => p.startsWith('/payment') || p === '/product_pay' || p === '/user_payment_check',
    label: '결제'
  }
];

export default {
  name: 'GitbookHelpLink',
  props: {
    inline: { type: Boolean, default: false }
  },
  computed: {
    helpLinks() {
      const routeName = this.$route.name;
      const links = ROUTE_HELP_MAP[routeName];
      if (!links) return null;
      return links.map(link => ({
        text: link.text,
        url: link.url || GITBOOK_BASE + link.path
      }));
    },
    routeLabel() {
      const path = this.$route.path;
      const matched = PATH_LABEL_RULES.find(rule => rule.test(path));
      return matched ? matched.label : '도움말';
    }
  }
};
</script>

<style scoped>
.gitbook-help-wrapper {
  display: inline-flex;
  align-items: center;
}

.gitbook-help-btn {
  display: inline-flex;
  align-items: center;
  font-size: 0.8rem;
  color: #6c757d;
  white-space: nowrap;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 3px 10px;
  transition: color 0.2s, border-color 0.2s, background-color 0.2s;
}

.gitbook-help-toggle:hover .gitbook-help-btn,
.gitbook-help-toggle:focus .gitbook-help-btn {
  color: #17a2b8;
  border-color: #17a2b8;
  background-color: rgba(23, 162, 184, 0.05);
}

.gitbook-help-toggle {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  line-height: 1;
}
</style>
